import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { VISION_PROPERTY } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

@Component({
  selector: 'vision-icon-renderer',
  template: ` <wiz-hgroup
    #hgContainer
    height="100%"
    width="100%"
    verticalAlign="center"
    gap="3">
    <wiz-image width="25px" height="25px" [visible]="!!vision.icon" [sourceObservable]="iconOrDie" style="align-self: center;"></wiz-image>
    <wiz-image #imgRunMode [source]="modeIcon" width="25x" height="25px"></wiz-image> 
    <wiz-label [wizLabel]="vision.code" [wizTextBehavior]="'truncate'"></wiz-label>
  </wiz-hgroup>`,
  styles: [':host {max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

/**
 * Renderer des actions sur une application dans le grid
 */
export class VisionIconRenderer implements AgRendererComponent {
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  public vision: VisionVO;

  public get modeIcon(): any {
    return Model.getInstance().visionEngine.getVisionProperties(this.vision, VISION_PROPERTY.RUN_MODE_ICON);
  }

  public get iconOrDie(): Observable<string> {
    return Model.getInstance().visionEngine.getVisionIconOrDie(this.vision);
  }



  refresh(params: ICellRendererParams): boolean {
    this.vision = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.vision = params.data;
    this.cdref.markForCheck();
  }
}
